import { memo } from 'react'

import PrivacyPolicyDE from './PrivacyPolicyDE'

const PrivacyPolicyRoute = () => (
  <PrivacyPolicyDE />
)

export default memo(PrivacyPolicyRoute)
